module.exports = __webpack_public_path__ + "static/media/2.question.5b7f240b.mp4";